import { render, staticRenderFns } from "./activeSchoolStatis.vue?vue&type=template&id=5546a92e&scoped=true"
import script from "./activeSchoolStatis.vue?vue&type=script&lang=js"
export * from "./activeSchoolStatis.vue?vue&type=script&lang=js"
import style0 from "./activeSchoolStatis.vue?vue&type=style&index=0&id=5546a92e&prod&lang=scss&scoped=true"
import style1 from "./activeSchoolStatis.vue?vue&type=style&index=1&id=5546a92e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546a92e",
  null
  
)

export default component.exports